import React, { useState } from 'react';
import { getFullNameByEmail } from '../../App';

const AdminFaultReports = ({ tickets, users, onUpdateStatus }) => {
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterPriority, setFilterPriority] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const faultTickets = tickets.filter(ticket => ticket.type === 'ariza');

  const filteredTickets = faultTickets.filter(ticket => {
    const matchesStatus = filterStatus === 'all' || ticket.status === filterStatus;
    const matchesPriority = filterPriority === 'all' || ticket.priority === filterPriority;
    const matchesSearch = ticket.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         ticket.user_email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         (ticket.product_name && ticket.product_name.toLowerCase().includes(searchTerm.toLowerCase()));
    
    return matchesStatus && matchesPriority && matchesSearch;
  });

  const getStatusLabel = (status) => {
    const labels = {
      open: '🔴 Açık',
      in_progress: '🟡 İşlemde',
      closed: '🟢 Kapalı',
      procurement: '🟣 Tedarik Sürecinde'
    };
    return labels[status] || status;
  };

  const getPriorityLabel = (priority) => {
    const labels = {
      low: '🟢 Düşük',
      normal: '🟡 Normal',
      high: '🟠 Yüksek',
      urgent: '🔴 Acil'
    };
    return labels[priority] || priority;
  };

  const getStatusStats = () => {
    return {
      total: faultTickets.length,
      open: faultTickets.filter(t => t.status === 'open').length,
      inProgress: faultTickets.filter(t => t.status === 'in_progress').length,
      closed: faultTickets.filter(t => t.status === 'closed').length
    };
  };

  // Stat karta tıklandığında filtreyi değiştir
  const handleStatClick = (status) => {
    setFilterStatus(status);
  };

  const stats = getStatusStats();

  return (
    <div className="admin-fault-reports">
      <div className="fault-reports-header">
        <h3>Arıza Kayıtları ({faultTickets.length})</h3>
        
        {/* İstatistikler - Tıklanabilir */}
        <div className="fault-stats-grid">
          <div 
            className={`fault-stat-item total ${filterStatus === 'all' ? 'active' : ''}`}
            onClick={() => handleStatClick('all')}
            style={{ cursor: 'pointer' }}
          >
            <span className="stat-number">{stats.total}</span>
            <span className="stat-label">Toplam</span>
          </div>
          <div 
            className={`fault-stat-item open ${filterStatus === 'open' ? 'active' : ''}`}
            onClick={() => handleStatClick('open')}
            style={{ cursor: 'pointer' }}
          >
            <span className="stat-number">{stats.open}</span>
            <span className="stat-label">Açık</span>
          </div>
          <div 
            className={`fault-stat-item progress ${filterStatus === 'in_progress' ? 'active' : ''}`}
            onClick={() => handleStatClick('in_progress')}
            style={{ cursor: 'pointer' }}
          >
            <span className="stat-number">{stats.inProgress}</span>
            <span className="stat-label">İşlemde</span>
          </div>
          <div 
            className={`fault-stat-item closed ${filterStatus === 'closed' ? 'active' : ''}`}
            onClick={() => handleStatClick('closed')}
            style={{ cursor: 'pointer' }}
          >
            <span className="stat-number">{stats.closed}</span>
            <span className="stat-label">Kapalı</span>
          </div>
        </div>
      </div>

      {/* Filtreler */}
      <div className="fault-filters">
        <div className="filter-group">
          <input
            type="text"
            placeholder="Arıza ara... (başlık, kullanıcı, ürün)"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        
        <div className="filter-group">
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">Tüm Durumlar</option>
            <option value="open">Açık</option>
            <option value="in_progress">İşlemde</option>
            <option value="closed">Kapalı</option>
          </select>
        </div>

        <div className="filter-group">
          <select
            value={filterPriority}
            onChange={(e) => setFilterPriority(e.target.value)}
            className="filter-select"
          >
            <option value="all">Tüm Öncelikler</option>
            <option value="urgent">Acil</option>
            <option value="high">Yüksek</option>
            <option value="normal">Normal</option>
            <option value="low">Düşük</option>
          </select>
        </div>
      </div>

      {/* Arıza Listesi */}
      {filteredTickets.length === 0 ? (
        <div className="no-data">
          {searchTerm || filterStatus !== 'all' || filterPriority !== 'all' 
            ? 'Filtrelere uygun arıza kaydı bulunamadı.' 
            : 'Henüz hiç arıza kaydı bulunmuyor.'}
        </div>
      ) : (
        <div className="fault-tickets-list">
          {filteredTickets.map(ticket => (
            <div key={ticket.id} className={`fault-ticket-card priority-${ticket.priority} status-${ticket.status}`}>
              <div className="fault-ticket-header">
                <div className="fault-info">
                  <h4>{ticket.title}</h4>
                  <div className="fault-meta">
                    <span className="fault-user">👤 {getFullNameByEmail(ticket.user_email, users)}</span>
                    <span className="fault-date">📅 {new Date(ticket.created_at).toLocaleDateString('tr-TR')}</span>
                  </div>
                </div>
                <div className="fault-badges">
                  <span className={`priority-badge ${ticket.priority}`}>
                    {getPriorityLabel(ticket.priority)}
                  </span>
                  <span className={`status-badge ${ticket.status}`}>
                    {getStatusLabel(ticket.status)}
                  </span>
                </div>
              </div>

              {ticket.product_name && (
                <div className="fault-product">
                  <strong>🔧 Arızalı Ürün:</strong> {ticket.product_name} ({ticket.product_code})
                </div>
              )}

              <div className="fault-description">
                <strong>📝 Arıza Açıklaması:</strong>
                <p>{ticket.description}</p>
              </div>

              <div className="fault-actions">
                <div className="status-update">
                  <label>Durum Güncelle:</label>
                  <div className="status-buttons">
                    <button 
                      onClick={() => onUpdateStatus(ticket.id, 'open')}
                      className={`btn-status-fault ${ticket.status === 'open' ? 'active' : ''}`}
                    >
                      🔴 Aç
                    </button>
                    <button 
                      onClick={() => onUpdateStatus(ticket.id, 'in_progress')}
                      className={`btn-status-fault ${ticket.status === 'in_progress' ? 'active' : ''}`}
                    >
                      🟡 İşlemde
                    </button>
                    <button 
                      onClick={() => onUpdateStatus(ticket.id, 'closed')}
                      className={`btn-status-fault ${ticket.status === 'closed' ? 'active' : ''}`}
                    >
                      🟢 Kapat
                    </button>
                  </div>
                </div>
              </div>

              <div className="fault-footer">
                <small>
                  Oluşturulma: {new Date(ticket.created_at).toLocaleString('tr-TR')}
                  {ticket.updated_at !== ticket.created_at && (
                    <> | Güncelleme: {new Date(ticket.updated_at).toLocaleString('tr-TR')}</>
                  )}
                </small>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminFaultReports;